import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate } from '../../appconfig/Settings';

import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import moment from 'moment';
import { getAllDetailsDirect } from '../../service/ProductService';
import { GET_BILLING } from '../../config/ApiConstant';
import { BillingListColumns } from '../../appconfig/DatatableSetting';
import { amountFormate, formatDateTime } from '../../appconfig/AppHelper';
import { Button } from 'primereact/button';
import CustomDatePicker from '../../components/CustomDatePicker/CustomDatePicker';

export const Billing = () => {
    document.title = 'Billing | GSPC';

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState({
        start: new Date(today.setDate(today.getDate() - 31)),
        end: new Date()
    });

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [billingList, setBillingList] = useState<any>([]);
    const [totalAmount, setTotalAmount] = useState<any>(0);

    // useEffect
    useEffect(() => {
        getBillingList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates]);

    // Get electoral applications
    const getBillingList = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetailsDirect(GET_BILLING + '?start_date=' + startDate + '&end_date=' + endDate);
            if (response) {
                const DataList: any = response.List;
                if (DataList.length === 0) {
                    setBillingList([]);
                } else {
                    setBillingList(DataList);
                    setTotalAmount(response.totalamount);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setBillingList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setBillingList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange}  />

                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary ml-2"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Datatable footer group
    const footerGroup = () => {
        return billingList.length > 0 ? (
            <ColumnGroup>
                <Row>
                    <Column footer={<b>Total:</b>} colSpan={3} footerStyle={{ textAlign: 'left' }} />
                    <Column footer={<b>{amountFormate(totalAmount) + '.00'}</b>} />
                    <Column footer={''} colSpan={4} />
                </Row>
            </ColumnGroup>
        ) : (
            <></>
        );
    };

    // Template for amount
    const amountTemplate = (rowData: any) => {
        return <>{!window.cn(rowData.TotalAmt) ? amountFormate(rowData.TotalAmt) + '.00' : '0.00'}</>;
    };

    // Template for patment date
    const PayDtTemplate = (rowData: any) => {
        return (
            <>
                <div>{!window.cn(rowData?.PayDt) ? formatDateTime(rowData?.PayDt) : '-'}</div>
            </>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Dashboard'} pageName={'Billing'} pageTitle={'Billing'} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={billingList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={billingList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Data Found"
                                    footerColumnGroup={footerGroup()}
                                    removableSort
                                >
                                    {BillingListColumns.map((col, i) => {
                                        if (col.field === 'PayDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={PayDtTemplate} />;
                                        } else if (col.field === 'TotalAmt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                                        } else if (col.field === 'EntryNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'bRegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'StudNm') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'BillSrNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'AppNm') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {BillingListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
